module.exports = __webpack_public_path__ + "static/media/facilityName.a32cca2a.svg";